<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Inventory</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" md="3">
            <v-autocomplete name="checkStockStore" dense outlined v-model="queryStore" :items="stores"
              label="Select Branch / Shop" item-text="Name" item-value="id" @change="queryData"></v-autocomplete>
          </v-col>

           <v-col cols="12" md="6">
            <v-autocomplete :filter="customFilter" style="width: 500px" autocomplete="off" v-model="select"
              :isloading="isLoading" :items="products" :search-input.sync="searchProducts"
              @change="queryStockBalance(select)" :item-text="smsRef == 'pharmacy' ? 'full_name' : 'Name'" item-value="id"
              cache-items  flat hide-no-data hide-details label="Search Product" outlined dense>
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title>{{ data.item.Name
                  }}</v-list-item-title>

                </v-list-item-content>
              </template>
            </v-autocomplete>

          </v-col>

          <v-col cols="12" xs="12" md="3">
            <v-autocomplete
              name="brandFilter"
              dense
              outlined
              v-model="selectedBrand"
              :items="brands"
              label="Select Brand"
              item-text="Name"
              item-value="id"
              clearable
              @change="queryData"
            ></v-autocomplete>
          </v-col>

         
        </v-row>

        <v-divider></v-divider>

        <v-row dense class="mt-2">
          <v-col cols="12" xs="12" md="12">
            <v-row>

              <v-col cols="12" md="1">
                <!-- excel icon -->
                <download-excel :data="inventory" :fields="fields" name="Stock List">
                  <v-icon color="green">mdi-file-excel</v-icon>
                </download-excel>
                <!-- end -->
              </v-col>

              <v-col cols="4">
                <v-btn v-if="inventory.length > 0" color="accent" @click="printStockViaThermal" text>
                  <v-icon left>mdi-printer</v-icon>Print Stock Via Thermal
                </v-btn>
              </v-col>

              <v-col cols="12" style="margin-top: -20px">
                <!-- start of table -->
                <v-data-table :loading="loader" loading-text="Loading Data......" :headers="headers" :items="inventory"
                  :items-per-page="2000">
                  <template v-slot:item.Name="{ item }">
                    <v-btn color="primary" text :to="`/quick-audit/${item.productId}`">{{
                      item.Name }}</v-btn>
                  </template>

                  <template v-slot:item.AvailableQty="{ item }">
                    <span>{{ item.purchaseUomQty }}</span>
                  </template>

                  <template v-slot:item.PurchaseUnit="{ item }">
                    <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.PurchaseUnit }}</span>
                  </template>

                  <template v-slot:item.BaseUnitStock="{ item }">
                    <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.BaseUnitStock }}</span>
                  </template>

                  <template v-slot:item.BaseUnit="{ item }">
                    <span v-if="item.HasUom == 1 && item.BaseStockActive == 'N'">{{ item.BaseUnit }}</span>
                  </template>

                </v-data-table>
                <!-- end -->
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- snackbar -->

      <!-- printer div -->
      <div id="print-stock" v-show="showPrinterDiv" style>

        <!-- section 1 -->
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;"> Date: {{ todayDate }}</span><br><br>

            <span style="font-size: 18px; font-weight: bold;"> Stock List</span><br><br>

          </div>
        </div>
        <!-- end -->


        <!-- section 1 -->
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;"> {{ selectedStoreName }}</span><br><br>

          </div>
        </div>
        <!-- end -->

        <span>-------------------------------------------------------</span>

        <div
          style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
          <span style="width: 70%; text-align: left; padding-left: 2px;">Item Name</span>

          <span style="width: 30%; text-align: left; padding-right: 5px">Qty</span>
        </div><br>

        <div v-for="(item, index) in inventory" :key="index" style="font-size: 14px;">
          <div style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
            <span style="width: 70%; text-align: left; padding-left: 2px;">{{ item.Name }}</span>

            <span style="width: 30%; text-align: left; padding-right: 5px">{{ item.AvailableQty }}</span>
          </div>
          <span>-------------------------------------------------------</span>
        </div><br>


      </div>
      <!-- end of printing div -->


      <snackbar ref="snackbar"></snackbar>
    </v-card>
  </v-container>
</template>


<script>
export default {
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  data() {
    return {
      MultipleCashiersBackend: "N",
      selectedStoreName: "",
      showPrinterDiv: false,
      DefaultDistributorCustomer: 0,
      smsRef: "",
      select: "",
      isLoading: false,
      search: null,
      searchStock: null,
      pageItems: 500,
      loader: false,
      editItem: {},
      damagedItem: {},
      transferItem: {},
      store: null,
      queryStore: null,
      stores: [],
      users: [],
      date: null,
      dialog: false,
      damageDialog: false,
      transferDialog: false,
      searchProducts: null,
      todayDate: new Date().toISOString().substr(0, 10),
      brands: [],
      selectedBrand: null,
      products: [],
      headers: [
        // { text: "Item Code", value: "ItemCode" },
        { text: "Product Name", value: "Name" },
        { text: "Available Qty", value: "AvailableQty" },
        // { text: "Purchase Unit", value: "purchaseUomQty" },
        { text: "Purchase Uom", value: "PurchaseUnit" },
        { text: "Base Unit Stock", value: "BaseUnitStock" },
        { text: "Base Unit", value: "BaseUnit" },
        // { text: "Remainder", value: "remainder" },
      ],
      fields: {
        ItemCode: "ItemCode",
        Product: "Name",
        AvailableQty: "AvailableQty",
      },
      inventory: [],
    };
  },
  watch: {
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    },
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const words = queryText.toLowerCase().split(/\s+/)
      const text = itemText.toLowerCase()
      return words.every(word => text.includes(word))
    },
    queryData() {
      const id = this.queryStore;
      if (!id) return;

      var selectedStore = this.stores.find((record) => {
        return record.id === id;
      });

      const pos = this.stores.indexOf(selectedStore);
      if (pos === -1) {
        return;
      }

      this.selectedStoreName = selectedStore.Name;

      let url = `/check-stock/${id}`;
      if (this.selectedBrand) {
        url += `?brandId=${this.selectedBrand}`;
      }

      const self = this;
      self.loader = true;
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            if (res.ResponseData != null) {
              self.inventory = res.ResponseData;
            }

            if (res.ResponseData == null) {
              self.inventory = [];
            }


          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    queryStockBalance(val) {

      if (this.queryStore == null || this.queryStore == undefined) {
        this.$refs.snackbar.show("Please select store / branch ", "red");
        return;
      }

      const self = this;

      var storeId = parseInt(this.queryStore);
      var productId = parseInt(val);

      const url = `/get-stock-balance/${storeId}/${productId}`;

      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.inventory = res.ResponseData;
              self.select = "";
            }

            if (res.ResponseData == null) {
              self.inventory = [];
            }

          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";

      var customerId = 0;

      const data = {
        SearchText: String(searchText),
        CustomerId: parseInt(customerId)
      };

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            if (res.ResponseData != null) {
              self.products = res.ResponseData;
            }
          } else {
            self.$store.commit("btnLoader", false);
            // this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(() => {
          self.$store.commit("btnLoader", false);
          // this.$refs.snackbar.show(err, "red");
        });
    },
    printStockViaThermal() {
      // Get the HTML content you want to print
      const content = document.getElementById("print-stock").innerHTML;

      // Open a new print window
      const printWindow = window.open(
        "",
        "",
        "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
      );

      // Write the HTML to the print window, including the content
      printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            width: 80mm;
            margin: 0 auto;
          }
          @page {
            size: auto;  /* auto is the current printer page size */
            margin: 0mm; /* this affects the margin in the printer settings */
          }
        </style>
      </head>
      <body onload="window.print(); window.close();">${content}</body>
    </html>
  `);

      printWindow.document.close();
    },
    getBrands() {
      const self = this;
      this.$store
        .dispatch("get", `/brands`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.brands = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      var userId = localStorage.getItem("userId");
      const self = this;

      var url = "";

      if (this.MultipleCashiersBackend == "Y") {
        url = `/user-stores/${userId}`;
      }

      if (this.MultipleCashiersBackend != "Y") {
        url = `/stores`;
      }

      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    glAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/gl-integration`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.DefaultDistributorCustomer = res.ResponseData.DefaultDistributorCustomer;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/general-settings`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.MultipleCashiersBackend = res.ResponseData.MultipleCashiersBackend;
            self.getStores();
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    Promise.all([this.glAccounts(), this.getGenSettings(), this.getBrands()]);
  },
};
</script>

<style lang="scss" scoped></style>